export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-brush/index.js
// module id = ../../../../d3-brush/index.js
// module chunks = 4